import { render, staticRenderFns } from "./EditBox.vue?vue&type=template&id=2d518894&"
import script from "./EditBox.vue?vue&type=script&lang=js&"
export * from "./EditBox.vue?vue&type=script&lang=js&"
import style0 from "./EditBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports